export const WS_ASSETS_REGEXP = /[^/\w]\/ws\/[-\w/.]+/gm;
export const PROHIBITED_HTML_TAGS_REGEXP =
  /(?:(?:<\s*(title)[^>]*>)(?:.|\n)*(?:<\/\s*\1\s*>))|(?:<\s*base[^>]*(?:\/)?>)/gm;
export const WS_ASSETS_ERROR_MESSAGE =
  'Internal website assets can not be referenced in custom code.';
export const PROHIBITED_HTML_TAGS_ERROR_MESSAGE = '<title> and <base> tags are prohibited.';
